import { CaretDown, Check, GlobeHemisphereWest, User, UsersThree } from '@phosphor-icons/react';
import { MenueEintrag, MenueTitel, Popover } from '../../../../components/immobilien/ui';
import type { ZustaendigOption } from '../../../../lib/immobilien/useObjektListe';

/** Zuständigkeit direkt in der Liste ändern (Global, Mitarbeiter, Teams) – wie bisher. */
export function ZustaendigMenue({ aktuell, aktuellId, mitarbeiter, teams, laeuft, onWahl }: {
  aktuell: string;
  aktuellId: string | null;
  mitarbeiter: ZustaendigOption[];
  teams: ZustaendigOption[];
  laeuft: boolean;
  onWahl: (ziel: ZustaendigOption | null) => void;
}) {
  return (
    <Popover
      label="Zuständigkeit wählen"
      ausrichtung="links"
      breite={240}
      ausloeser={({ offen, umschalten, ref }) => (
        <button
          ref={ref}
          type="button"
          aria-haspopup="menu"
          aria-expanded={offen}
          disabled={laeuft}
          onClick={e => { e.stopPropagation(); umschalten(); }}
          className="immo-hover-flaeche inline-flex items-center max-w-full cursor-pointer"
          style={{ gap: 6, height: 30, padding: '0 10px', borderRadius: 15, border: 'none', background: 'var(--fill2)', fontSize: 12, fontWeight: 600, color: 'var(--ink2)', opacity: laeuft ? 0.5 : 1 }}
        >
          <span className="truncate">{aktuell}</span>
          <CaretDown weight="bold" size={11} />
        </button>
      )}
    >
      {schliessen => {
        const waehle = (z: ZustaendigOption | null) => { schliessen(); onWahl(z); };
        const eintrag = (z: ZustaendigOption) => (
          <MenueEintrag key={`${z.typ}-${z.id}`} aktiv={aktuellId === z.id} onClick={() => waehle(z)}>
            {z.typ === 'team' ? <UsersThree size={15} /> : <User size={15} />}
            <span className="flex-1 truncate">{z.name}</span>
            {aktuellId === z.id && <Check weight="bold" size={13} />}
          </MenueEintrag>
        );
        return (
          <>
            <MenueEintrag aktiv={!aktuellId} onClick={() => waehle(null)}>
              <GlobeHemisphereWest size={15} />
              <span className="flex-1">Global</span>
              {!aktuellId && <Check weight="bold" size={13} />}
            </MenueEintrag>
            {mitarbeiter.length > 0 && <MenueTitel>Mitarbeiter</MenueTitel>}
            {mitarbeiter.map(eintrag)}
            {teams.length > 0 && <MenueTitel>Teams</MenueTitel>}
            {teams.map(eintrag)}
          </>
        );
      }}
    </Popover>
  );
}
